<template lang="pug">
.d-flex
  .flex-grow-1
    filter-name.mr-2(ref="name" :filter.sync="nameFilter" check-initial-value)
    filter-user.mr-2(ref="user" :filter.sync="userFilter" check-initial-value)
    filter-date.mr-2(ref="start" :filter.sync="startDateFilter" title="Start count date" param="start_date" check-initial-value)
    filter-date.mr-2(ref="end" :filter.sync="endDateFilter" title="End count date" param="end_date" check-initial-value)
    filter-status.mr-2(ref="status" :filter.sync="statusFilter" :statuses="statuses" check-initial-value)
  v-btn.button-sm.underline.px-0(text @click="resetFilters" :disabled="allFilters.length === 0") Reset filters
</template>

<script>
import FilterName from '@/components/module/filter/FilterName.vue'
import FilterUser from '@/components/module/filter/FilterUser.vue'
import FilterDate from '@/components/module/filter/FilterDate.vue'
import FilterStatus from '@/components/module/filter/FilterStatus.vue'

export default {
  name: 'FilterServicesRow',
  components: { FilterName, FilterUser, FilterDate, FilterStatus },
  props: ['filters', 'propFilters'],
  data: () => ({
    nameFilter: {},
    userFilter: {},
    startDateFilter: {},
    endDateFilter: {},
    statusFilter: {},
    statuses: [
      { id: 'in_progress', name: 'In progress', isChecked: false },
      { id: 'finished', name: 'Finished', isChecked: false },
    ]
  }),
  computed: {
    allFilters () {
      const filters = []
      if (this.nameFilter.key) {
        filters.push(this.nameFilter)
      }
      if (this.userFilter.key) {
        filters.push(this.userFilter)
      }
      if (this.startDateFilter.key) {
        if (this.startDateFilter.key === 'between') {
          const values = this.startDateFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.startDateFilter)
        }
      }
      if (this.endDateFilter.key) {
        if (this.endDateFilter.key === 'between') {
          const values = this.endDateFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.endDateFilter)
        }
      }
      if (this.statusFilter.key) {
        filters.push(this.statusFilter)
      }
      return filters
    },
    dataFilters () {
      return {
        nameFilter: this.nameFilter,
        userFilter: this.userFilter,
        startDateFilter: this.startDateFilter,
        endDateFilter: this.endDateFilter,
        statusFilter: this.statusFilter,
      }
    }
  },
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  methods: {
     setFilters () {
      this.nameFilter = this.propFilters?.nameFilter || {}
      this.userFilter = this.propFilters?.userFilter || {}
      this.startDateFilter = this.propFilters?.startDateFilter || {}
      this.endDateFilter = this.propFilters?.endDateFilter || {}
      this.statusFilter = this.propFilters?.statusFilter || {}
      this.$nextTick(() => {
        this.$refs.name.setData()
        this.$refs.user.setData()
        this.$refs.start.setData()
        this.$refs.end.setData()
        this.$refs.status.setData()
      })
    },
    resetFilters () {
      this.nameFilter = {}
      this.userFilter = {}
      this.startDateFilter = {}
      this.endDateFilter = {}
      this.statusFilter = {}
    }
  }
}
</script>